import { useAction, useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import { useMount } from 'react-use'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import {
  loadReferralLeaderboardAction,
  referralLeaderboardStateAtom,
} from '@root/entities/leaderboard'

import { LeaderboardTable } from './leaderboard-table'

import type { LeaderboardTableEntry } from '@root/features/leaderboard/model'

export const ReferralLeaderboardTable: React.FC = () => {
  const [state] = useAtom(referralLeaderboardStateAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const loadLeaderboard = useAction(loadReferralLeaderboardAction)

  useMount(() => {
    loadLeaderboard()
  })

  const mappedState = useMemo(
    () =>
      pipe(
        state,
        AsyncStateN.map((it) =>
          it.map(
            (item): LeaderboardTableEntry => ({
              date: item.registrationDate,
              name: item.username ?? '-',
              amount: item.totalReferralBalanceUsd,
              rank: item.position,
              userId: item.id,
              currencyTicker: nativeCurrency.ticker,
            }),
          ),
        ),
      ),
    [nativeCurrency.ticker, state],
  )

  return <LeaderboardTable onRetry={loadLeaderboard} items={mappedState} />
}
